// ========== Imports ==========
import { formatDate } from 'helpers/StringNumberFunction/formatDate';
import { moneyFunction } from 'helpers/StringNumberFunction/moneyFunction';
import { amtStr } from 'helpers/StringNumberFunction/numFormatter';

// ========== Component ==========
export const ELetterServiceSubcontract = ({
  docType,
  previewDetail,
  allpreviewDetail,
  getSubcontract,
  paramVal,
  ItemIndex,
}) => {
  // ========== Get Company Details from local storage ==========
  const companyDetails = JSON.parse(localStorage.getItem('companyDetails'));

  const subcontractData = previewDetail?.info || previewDetail;

  const getTradeData = (index = 0) => {
    const isMultipleTrade = subcontractData?.multipleTrade;

    if (isMultipleTrade) {
      const tradeWbs = subcontractData?.subcontractCostWbs?.[index];
      return {
        name: tradeWbs?.costCategory?.name ?? '',
        tradeAmt: tradeWbs?.tradeAmt ?? 0,
        revisedTradeAmt: tradeWbs?.revisedTradeAmt ?? tradeWbs?.tradeAmt ?? 0,
        tradeVoAmt: tradeWbs?.tradeVoAmt ?? 0,
      };
    } else {
      return {
        name: subcontractData?.tradeDetail?.name ?? '',
        tradeAmt: subcontractData?.subcontractSum ?? 0,
        revisedTradeAmt:
          subcontractData?.revisedSubcontractSum ??
          subcontractData?.subcontractSum ??
          0,
        tradeVoAmt: 0,
      };
    }
  };

  // ========== Construct Subcontract Details ==========
  const subcontractDetails = {
    '[subcontractCompanyName]':
      subcontractData?.subcontractorDetail?.name ?? '',
    '[subcontractRegistrationNo]':
      subcontractData?.subcontractorDetail?.registrationNo ?? '',
    '[subcontractAddress]': [
      // subcontractData?.subcontractorDetail?.name,
      subcontractData?.subcontractorDetail?.address?.address,
      subcontractData?.subcontractorDetail?.address?.postCode,
      subcontractData?.subcontractorDetail?.address?.city,
      subcontractData?.subcontractorDetail?.address?.state,
      subcontractData?.subcontractorDetail?.address?.country,
    ]
      .filter(Boolean)
      .join(', '),
    '[subcontractOfficeNo]':
      subcontractData?.subcontractorDetail?.contactNo ?? '',
    '[subcontractEmail]': subcontractData?.subcontractorDetail?.email ?? '',
    '[contractEndDate]': formatDate(subcontractData?.endDate) ?? '',
    '[createdBy]': subcontractData?.auditLog?.createdName ?? '',

    '[subcontractContactPerson]':
      subcontractData?.contactPerson?.[0]?.name ??
      subcontractData?.subcontractorDetail?.contactPerson?.[0]?.name ??
      subcontractData?.contact?.[0]?.name ??
      '',

    '[mainContract]': subcontractData?.mainContractDetail?.title ?? '',

    '[projectAddress]': [
      subcontractData?.site?.name,
      subcontractData?.site?.address?.address,
      subcontractData?.site?.address?.postCode,
      subcontractData?.site?.address?.city,
      subcontractData?.site?.address?.state,
      subcontractData?.site?.address?.country,
    ]
      .filter(Boolean)
      .join(', '),

    '[subcontractTitle]': subcontractData?.title ?? '',
    '[subcontractNo]': subcontractData?.subcontractNo ?? '',
    '[subcontractAwardedDate]':
      formatDate(subcontractData?.subcontractDate) ?? '',
    '[creditTerm]': subcontractData?.creditTerm ?? '',
    '[description]': subcontractData?.description ?? '',
    '[termsConditions]': subcontractData?.termsConditions?.description ?? '',

    '[subcontractorName]': subcontractData?.subcontractorDetail?.name ?? '',

    '[subcontractorAddress]': [
      subcontractData?.subcontractorDetail?.address?.address,
      subcontractData?.subcontractorDetail?.address?.address,
      subcontractData?.subcontractorDetail?.address?.postCode,
      subcontractData?.subcontractorDetail?.address?.city,
      subcontractData?.subcontractorDetail?.address?.state,
      subcontractData?.subcontractorDetail?.address?.country,
    ]
      .filter(Boolean)
      .join(', '),
    '[contractContactPerson]': subcontractData?.contact?.[0]?.name ?? '',
    '[contractContactNo]': subcontractData?.contact?.[0]?.contactNo ?? '',
    '[subcontractorContactNo]':
      subcontractData?.contactPerson?.contactNo ??
      subcontractData?.subcontractorDetail?.contactPerson?.[0]?.contactNo ??
      subcontractData?.contact?.[0]?.contactNo ??
      '',

    '[subcontractorEmail]':
      subcontractData?.contactPerson?.[0]?.email ??
      subcontractData?.subcontractorDetail?.contactPerson?.[0]?.email ??
      subcontractData?.contact?.[0]?.email ??
      subcontractData?.subcontractorDetail?.email ??
      '',

    '[subcontractorRegNo]':
      subcontractData?.subcontractorDetail?.registrationNo ?? '',

    '[docNo]': previewDetail?.docNo ?? '',
    '[docDate]': formatDate(previewDetail?.docDate) ?? '',
    '[docRef]': previewDetail?.docRef ?? '',
    '[companyCurrencyCode]':
      previewDetail?.user?.companyCurrencyCode ??
      companyDetails?.currencyCode ??
      '',
    '[currency]':
      previewDetail?.user?.companyCurrency ?? companyDetails?.currency ?? '',
    '[docAmt]': amtStr(previewDetail?.totalAmt),
  };

  // ========== Document Type Processing ==========
  switch (docType) {
    // =========================
    // SUBCONTRACT INFO
    // =========================
    case 'subcontract-info':
      // Get ALL trade data
      const allTradeData = subcontractData?.multipleTrade
        ? subcontractData?.subcontractCostWbs?.map((trade, index) => {
            const taxDetail = trade?.taxDetail;

            const taxRate =
              taxDetail?.taxSchemeDetails?.[0]?.taxSchemeDetailItems?.[0]?.tax
                ?.taxDetail?.[0]?.rate ?? 0;

            const taxAmt = trade?.tradeAmt * (taxRate / 100);

            return {
              index: index + 1,
              name: trade?.costCategory?.name ?? '',
              tradeAmt: trade?.tradeAmt ?? 0,
              revisedTradeAmt: trade?.revisedTradeAmt ?? trade?.tradeAmt ?? 0,
              tradeVoAmt: trade?.tradeVoAmt ?? 0,
              taxCode: taxDetail?.name ?? '',
              taxRate: taxRate,
              taxAmt: taxAmt,
              sumTaxAmt: amtStr(
                subcontractData?.subcontractCostWbs
                  ?.reduce(
                    (a, b) =>
                      a +
                      Number(
                        b?.tradeAmt *
                          ((b?.taxDetail?.taxSchemeDetails?.[0]
                            ?.taxSchemeDetailItems?.[0]?.tax?.taxDetail?.[0]
                            ?.rate ?? 0) /
                            100) || 0,
                      ),
                    0,
                  )
                  .toFixed(2),
              ),
            };
          }) || []
        : [
            {
              index: 1,
              name: subcontractData?.tradeDetail?.name ?? '',
              tradeAmt: subcontractData?.subcontractSum ?? 0,
              revisedTradeAmt:
                subcontractData?.revisedSubcontractSum ??
                subcontractData?.subcontractSum ??
                0,
              tradeVoAmt: 0,
              taxCode: subcontractData?.taxDetail?.name ?? '',
              taxRate:
                subcontractData?.taxDetail?.taxSchemeDetails?.[0]
                  ?.taxSchemeDetailItems?.[0]?.tax?.taxDetail?.[0]?.rate ?? 0,
              taxAmt:
                (subcontractData?.subcontractSum ?? 0) *
                (subcontractData?.taxDetail?.taxSchemeDetails?.[0]
                  ?.taxSchemeDetailItems?.[0]?.tax?.taxDetail?.[0]?.rate ?? 0),
              sumTaxAmt: amtStr(
                subcontractData
                  ?.reduce(
                    (a, b) =>
                      a +
                      Number(
                        b?.subcontractSum *
                          ((b?.taxDetail?.taxSchemeDetails?.[0]
                            ?.taxSchemeDetailItems?.[0]?.tax?.taxDetail?.[0]
                            ?.rate ?? 0) /
                            100) || 0,
                      ),
                    0,
                  )
                  .toFixed(2),
              ),
            },
          ];

      // Calculate totals for multiple trades
      const totalTradeAmt = allTradeData.reduce(
        (sum, trade) => sum + (trade.tradeAmt || 0),
        0,
      );
      const totalRevisedTradeAmt = allTradeData.reduce(
        (sum, trade) => sum + (trade.revisedTradeAmt || 0),
        0,
      );
      const totalTradeVoAmt = allTradeData.reduce(
        (sum, trade) => sum + (trade.tradeVoAmt || 0),
        0,
      );

      if (subcontractData?.multipleTrade && allTradeData.length > 1) {
        const formattedTradeNames = allTradeData
          .map(trade => `${trade.index}. ${trade.name}`)
          .join('<br/>');

        const primaryTax = allTradeData[0];

        return Object.assign(paramVal, subcontractDetails, {
          '[index]': '1',
          '[tradeName]': formattedTradeNames,
          '[tradeAmt]': amtStr(totalTradeAmt),
          '[tradeTotalAmt]': amtStr(totalRevisedTradeAmt),
          '[tradeVoAmt]': amtStr(totalTradeVoAmt),
          '[taxCode]': primaryTax.taxCode,
          '[taxRate]': primaryTax.taxRate.toString(),
          '[taxAmt]': amtStr(primaryTax.taxAmt),
          '[sumTaxAmt]': amtStr(primaryTax?.sumTaxAmt),

          '[preparedBy]':
            subcontractData?.auditLog?.createdName ??
            previewDetail?.generatedBy ??
            '',
          '[totalAmtInWords]': moneyFunction(
            subcontractData?.revisedSubcontractSum ??
              subcontractData?.subcontractSum ??
              0,
          ),
          '[subcontractSum]': amtStr(totalTradeAmt),
          '[revisedSubcontractSum]': amtStr(totalRevisedTradeAmt),
        });
      } else {
        const tradeData = allTradeData[0];
        return Object.assign(paramVal, subcontractDetails, {
          '[index]': tradeData.index.toString(),
          '[tradeName]': tradeData.name,
          '[tradeAmt]': amtStr(tradeData.tradeAmt),
          '[tradeTotalAmt]': amtStr(tradeData.revisedTradeAmt),
          '[tradeVoAmt]': amtStr(tradeData.tradeVoAmt),
          '[taxCode]': tradeData.taxCode,
          '[taxRate]': tradeData.taxRate.toString(),
          '[taxAmt]': amtStr(tradeData.taxAmt),
          '[sumTaxAmt]': amtStr(tradeData.sumTaxAmt),

          '[preparedBy]':
            subcontractData?.auditLog?.createdName ??
            previewDetail?.generatedBy ??
            '',
          '[totalAmtInWords]': moneyFunction(
            subcontractData?.revisedSubcontractSum ??
              subcontractData?.subcontractSum ??
              0,
          ),
          '[subcontractSum]': amtStr(subcontractData?.subcontractSum ?? 0),
          '[revisedSubcontractSum]': amtStr(
            subcontractData?.revisedSubcontractSum ??
              subcontractData?.subcontractSum ??
              0,
          ),
        });
      }
    default:
      return paramVal;
  }
};
